export const anwCategoryId = 'anw'
